import { ChartLayoutConfig } from '../common/layout-config';

export interface ChartMiscOptions {
  colors(layoutConfig: ChartLayoutConfig): string[];
}

export function createDefaultChartMiscOptions(): ChartMiscOptions {
  return {
    colors: (layoutConfig: ChartLayoutConfig) => {
      if (layoutConfig.layoutAttributes.Highcharts.theme && layoutConfig.layoutAttributes.Highcharts.theme.colors) {
        return layoutConfig.layoutAttributes.Highcharts.theme.colors.split(','); // May define several colors
      }
    }
  };
}
